<div class="modal-dialog">
  <div class="modal-content">
    <div class="modal-header">{{ data.headline }}</div>

    <!-- Help text (valid-feedback) is always shown, with d-block: the library hides it after any input
         marked .invalid, and a row-level error marks inputs whose own value is fine. It gives way
         only to that field's own message. Row-level messages are in app-rendition-errors below. -->
    <div [formGroup]="rendition" class="modal-body cl-form">
      <div>
        <label class="form-label" for="rendition_width">Width</label>
        <input [class.invalid]="showErrors && (rendition.get('width').errors)" class="it-rendition-width" formControlName="width" id="rendition_width" min="1" step="1" type="number">
        @if (showErrors && rendition.get('width').errors?.required) {
          <p class="invalid-feedback d-block">Enter a width in pixels.</p>
        } @else if (showErrors && rendition.get('width').errors?.min) {
          <p class="invalid-feedback d-block">Must be at least 1.</p>
        } @else {
          <p class="valid-feedback d-block">Output width in pixels. It also decides which DRM tier's key the rendition is encrypted with.</p>
        }
      </div>

      <div class="cl-spacing-small">
        <label class="form-label" for="rendition_avg_bitrate">Avg bitrate</label>
        <input [class.invalid]="showErrors && (rendition.get('avg_bitrate').errors || rendition.errors?.uncappedWithoutTarget || rendition.errors?.crfAndAvg)" class="it-rendition-avg-bitrate" formControlName="avg_bitrate" id="rendition_avg_bitrate" placeholder="—" type="text">
        @if (showErrors && rendition.get('avg_bitrate').errors?.bitrate) {
          <p class="invalid-feedback d-block">{{ bitrateHint }}</p>
        } @else {
          <p class="valid-feedback d-block">The bitrate two-pass encoding aims for. Not combined with a CRF on the same rendition.</p>
        }
      </div>

      <div class="cl-spacing-small">
        <label class="form-label" for="rendition_max_bitrate">Max bitrate</label>
        <input [class.invalid]="showErrors && (rendition.get('max_bitrate').errors || rendition.errors?.uncappedWithoutTarget || rendition.errors?.vbvWithoutCap)" class="it-rendition-max-bitrate" formControlName="max_bitrate" id="rendition_max_bitrate" placeholder="uncapped" type="text">
        @if (showErrors && rendition.get('max_bitrate').errors?.bitrate) {
          <p class="invalid-feedback d-block">{{ bitrateHint }}</p>
        } @else {
          <p class="valid-feedback d-block">Caps the bitrate and names the output file. Blank means uncapped: the rendition then needs its own CRF or average bitrate.</p>
        }
      </div>

      <div class="cl-spacing-small">
        <label class="form-label" for="rendition_crf">CRF</label>
        <input [class.invalid]="showErrors && (rendition.get('crf').errors || rendition.errors?.crfAndAvg || rendition.errors?.uncappedWithoutTarget)" [max]="data.crfMax" class="it-rendition-crf" formControlName="crf" id="rendition_crf" min="0" placeholder="—" step="0.1" type="number">
        @if (showErrors && rendition.get('crf').errors?.min) {
          <p class="invalid-feedback d-block">Must be 0 or more.</p>
        } @else {
          <p class="valid-feedback d-block">Constant-quality target for this rendition alone. Blank uses the group's CRF; not combined with an average bitrate.</p>
        }
      </div>

      <div class="cl-spacing-small">
        <label class="form-label" for="rendition_min_bitrate">Min bitrate</label>
        <input [class.invalid]="showErrors && (rendition.get('min_bitrate').errors || (rendition.errors?.vbvWithoutCap && rendition.get('min_bitrate').value))" class="it-rendition-min-bitrate" formControlName="min_bitrate" id="rendition_min_bitrate" placeholder="—" type="text">
        @if (showErrors && rendition.get('min_bitrate').errors?.bitrate) {
          <p class="invalid-feedback d-block">{{ bitrateHint }}</p>
        } @else {
          <p class="valid-feedback d-block">Lower bound for the rate window. Only takes effect under a max bitrate.</p>
        }
      </div>

      <div class="cl-spacing-small">
        <label class="form-label" for="rendition_bufsize">Buf size</label>
        <input [class.invalid]="showErrors && (rendition.get('bufsize').errors || (rendition.errors?.vbvWithoutCap && rendition.get('bufsize').value))" class="it-rendition-bufsize" formControlName="bufsize" id="rendition_bufsize" placeholder="—" type="text">
        @if (showErrors && rendition.get('bufsize').errors?.bitrate) {
          <p class="invalid-feedback d-block">{{ bitrateHint }}</p>
        } @else {
          <p class="valid-feedback d-block">Size of the rate-control buffer. Only takes effect under a max bitrate.</p>
        }
      </div>

      @if (showErrors) {
        <app-rendition-errors [codecLabel]="data.codecLabel" [crfMax]="data.crfMax" [rendition]="rendition" [twoPass]="data.twoPass" />
      }
    </div>

    <div class="modal-footer">
      <span class="modal-footer-left">
        <button (click)="dialogRef.close(false)" class="btn cl-color-secondary it-cancel" type="button">
          <span>Cancel</span>
        </button>
      </span>
      <span class="modal-footer-center"></span>
      <span class="modal-footer-right">
        <button (click)="dialogRef.close(true)" [disabled]="rendition.invalid" class="btn cl-color-primary it-ok" type="button">
          <span>{{ data.actionName }}</span>
        </button>
      </span>
    </div>
  </div>
</div>
